import {useState, useRef, useLayoutEffect } from 'react';
import {formatLabel} from "@/utils/utils"
import {useListingFilters} from "@/utils/listing-utils"
import type { Label, AccordionStyle } from "@/types/types.ts"

interface PolicyListingSelectFiltersProps {
    categories: Label[]
}

interface MultiSelectGroupProps {
    id: string,
    active: string | null,
    handleFunction: (accordionId: string) => void,
    title: string,
    data: Label[],
}

interface MultiSelectFilterProps {
    data: Label[],
    id: string
}

/**
 * Select Filters
 * Currently there is only 1 select filter (Categories)
 * This was copied over and modified from the Faculty Listing, which has multiple select filters.
 * In the Faculty Listing design, only 1 select filter can be open at a time. Although there is
 * only 1 select filter here, that logic was kept in case the client ever adds more, so that there
 * would be consistency with the other listings.
 */

export default function PolicyListingSelectFilters({categories}: PolicyListingSelectFiltersProps) {
    //state to track which accordion is open; currently business requirements call for only 1 accordion open at a time
    const [activeAccordion, setActiveAccordion] = useState<string | null>(null);


    const handleAccordionToggle = (accordionId: string) => {
        setActiveAccordion((prevId) => (prevId === accordionId ? null : accordionId));
    };

    return (
        <>
            <MultiSelectGroup id="cat" title="Category" active={activeAccordion} handleFunction={handleAccordionToggle} data={categories}  />
        </>
    );
}


export function MultiSelectGroup({id, active, handleFunction, title, data}: MultiSelectGroupProps ) {
    /*Used to preserve the slide up/down animation when you open/close accordions*/
    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);
    const isOpen = id === active;


    useLayoutEffect(() => {
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [isOpen]);


    return (
        <fieldset className="Finder__checkbox-group category-filter">
            <legend className="invis">{title}</legend>
            <button type="button" className="Finder__filter-toggle h5" id={id} onClick={() => handleFunction(id)} aria-expanded={id === active}>
                {title}
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg>
            </button>
            <div className="Finder__filter-content" style={{
                '--height': `${height}px`
            } as AccordionStyle}>
                <div ref={contentRef}>
                <MultiSelectFilter id={id} data={data} />
                </div>
            </div>
        </fieldset>
    );
}

export function MultiSelectFilter({data, id}: MultiSelectFilterProps) {
    if (!data) return;
    const { toggleLabel, search } = useListingFilters();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        toggleLabel(value);
    };

    return (
        <div className="inner">
            { data.map((cat) =>
                <label className="Finder__checkbox-label" key={`category-${cat.id}`}>
                    <input type="checkbox" className="Finder__checkbox" value={cat.name} name={id} checked={Boolean(search?.cat?.includes(cat.name))}  onChange={handleChange}/>{formatLabel(cat.name)}
                </label>
                )}
        </div>
    );
}

